import { SocketErrorCodes } from "sharedweb/app.structs";

export const ERRORCODES = [SocketErrorCodes.userAccountExpired, SocketErrorCodes.userLocked, SocketErrorCodes.userPasswordNotSet]